import type { QueryClient } from '@tanstack/query-core'

import {
  set_looking_for_change,
  keys as wallet_keys,
} from '../blockchain/useGetWalletBalance'
import { keys as portfolio_keys } from '../portfolio'

export async function token_balance_change({
  queryClient,
  token_address,
  wallet_address,
}: {
  queryClient: QueryClient
  token_address: CryptoAddress
  wallet_address: CryptoAddress
}) {
  set_looking_for_change(token_address)
  await queryClient.invalidateQueries({
    queryKey: wallet_keys.balance.wallet(wallet_address).queryKey,
  })

  await queryClient.invalidateQueries({
    queryKey: portfolio_keys.portfolio._def,
  })
}
